import { AxiosInstance } from "axios";
import { semvApi } from "../../../services/axios/apis.service";
import { MetricsBySecretaryContract } from "./contract";

class MetricsDatasource {
    private readonly api: AxiosInstance;

    constructor(api: AxiosInstance = semvApi) {
        this.api = api;
    }

    projectsMetricsBySecretary() {
        return this.api.get<{ metrics: MetricsBySecretaryContract[] }>(
            "government-plan/metrics/secretary"
        );
    }
}

export const govPlanMetricsDatasource = new MetricsDatasource();
